export default {"src":"/_next/static/media/TXN.49c30c12.svg","height":18,"width":18};